enum ActiveSurfaceView {
    AGENDA = 1,
    DAY,
}

export default ActiveSurfaceView;
